import { Component, Input, OnInit, Optional } from '@angular/core'
import { IcosSelect } from './select'

@Component({
  selector: 'icos-option',
  template: `
    <li class="icos-select-dropdown__item"
      [class.is-disabled]="icosDisabled || rootDisabled"
      [class.selected]="itemSelected"
      (click)="clickHandle($event)">
      <span>{{ label }}</span>
    </li>
  `,
})
export class IcosOption implements OnInit {

  @Input() set disabled(val: boolean) {   // todo, is discarded.
    console.warn('icos Angular: (disabled) is discarded, use [icosDisabled] replace it.')
  }
  @Input() icosDisabled: boolean = false
  @Input() value: any
  @Input() label: string | number

  rootDisabled: boolean = false
  itemSelected: boolean = false

  constructor(
    @Optional() private rootSelect: IcosSelect,
  ) {
  }

  clickHandle(event: Event): void {
    event.stopPropagation()
    if (this.icosDisabled || this.rootDisabled) return
    this.rootSelect.changeLabel(this.label, this.value)
  }

  ngOnInit(): void {
    const updateHandle = () => {
      if (this.rootSelect.multiple) {
        this.itemSelected = Array.isArray(this.rootSelect.model) && this.rootSelect.model.indexOf(this.value) > -1
      } else {
        this.itemSelected = this.value === this.rootSelect.model
      }
      this.itemSelected && this.rootSelect.changeLabel(this.label)
    }
    this.rootDisabled = this.rootSelect.icosDisabled
    updateHandle()
    this.rootSelect.subscriber.push(updateHandle)
    this.rootSelect.appendOptions({
      value: this.value,
      label: this.label,
    })
  }
}
